var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs.length)?_c('div',{staticClass:"tabs-link-container"},_vm._l((_vm.tabs),function(item,index){return _c('router-link',{key:index,staticClass:"tabs-link",attrs:{"to":item.path,"active-class":"cur"}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }